const PAYMENT_SKELETON_COMMON_PROPS = {
    shapeVariant: 'SQUARE',
    variant: 'SQUARE_DEFAULT',
    height: '48px',
    width: '100%',
  },
  PAYMENT_SKELETON_TITLE_PROPS = PAYMENT_SKELETON_COMMON_PROPS,
  PAYMENT_SKELETON_INPUT_PROPS = PAYMENT_SKELETON_COMMON_PROPS;

export { PAYMENT_SKELETON_TITLE_PROPS, PAYMENT_SKELETON_INPUT_PROPS };
